import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { CheckCircle2 } from 'lucide-react';

const Services = () => {
  return (
    <section id="services" className="py-24 bg-gradient-to-br from-gray-50 to-blue-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
              Improved Banking
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Our core microfinance solution suite offers a flexible approach to technology adoption with a cloud first approach. Our robust Core Microfinance Solution Suite allows both deposit taking and non-deposit taking microfinance institutions to swiftly migrate to cutting edge technology allowing comprehensive and extensive functional coverage.
            </p>
            
            <div className="space-y-4 mb-8">
              {[
                'Cloud-first architecture for maximum scalability',
                'Comprehensive functional coverage',
                'Automated Loan Origination Solution',
                'Agency banking for branchless banking',
                'Flexible and customizable platform'
              ].map((feature, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <CheckCircle2 className="h-6 w-6 text-blue-600 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">{feature}</span>
                </div>
              ))}
            </div>

            <Button 
              size="lg"
              className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
            >
              Contact Us
            </Button>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-100 to-cyan-100 rounded-3xl transform rotate-3" />
            <img 
              src="https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=1200&h=800&fit=crop"
              alt="Improved Banking"
              className="relative rounded-3xl shadow-2xl w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;